import { resources } from "@constants/hardcoded-strings";
import { SelectFormGroup } from "../select-form-group/select-form-group";
import { BaseSelectFormGroupProps } from "./base-select-form-group-props";

type SecurityRuleOperationTypeSelectFormGroupProps = BaseSelectFormGroupProps;


export const SecurityRuleOperationTypeSelectFormGroup = (
    props: SecurityRuleOperationTypeSelectFormGroupProps
) => {
    const { onChange, selectedOption, idPrefix, disabled, isRequired, isSearchable, isClearable, labelWidth } = props;

    const securityRuleOperationTypeOptions = [
        { label: "LIST", value: "LIST" },
        { label: "VIEW", value: "VIEW" },
        { label: "CREATE", value: "CREATE" },
        { label: "MODIFY", value: "MODIFY" },
        { label: "DELETE", value: "DELETE" },
        { label: "SUBMIT", value: "SUBMIT" },
        { label: "CANCEL", value: "CANCEL" },
        { label: "REVIEW", value: "REVIEW" },
        { label: "DEPLOY", value: "DEPLOY" },
        { label: "REFRESH", value: "REFRESH" }
    ];

    return (
        <SelectFormGroup
            controlId={`${idPrefix}-security-rule-operation-type-select`}
            label={resources.common.inputs.operationType.label}
            ariaLabel={resources.common.inputs.operationType.label}
            automationId={`${idPrefix}-security-rule-operation-type-select`}
            onChange={onChange}
            options={securityRuleOperationTypeOptions}
            selectedOption={selectedOption}
            disabled={disabled}
            isRequired={isRequired}
            isSearchable={isSearchable}
            isClearable={isClearable}
            labelWidth={labelWidth}
        />
    );
};